import PropTypes from 'prop-types';

export const ColorPalettePropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string,
  description: PropTypes.string,
  website: PropTypes.number,
  type: PropTypes.string,
});
